module.exports = __webpack_public_path__ + "files/1728fd5a009aabc77654b1f958c6f596.png";


//////////////////
// WEBPACK FOOTER
// ./images/favicon/apple-touch-icon-72x72.png
// module id = 1962
// module chunks = 60